import { render } from "./job-detail.vue?vue&type=template&id=0fe9c3b1&scoped=true"
import script from "./job-detail.vue?vue&type=script&lang=js"
export * from "./job-detail.vue?vue&type=script&lang=js"

import "./job-detail.vue?vue&type=style&index=0&id=0fe9c3b1&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe9c3b1"]])

export default __exports__